<template>
  <keep-alive>
    <div class="search" v-cloak>
      <div class="detai_box_img">
        <el-carousel
          :interval="5000"
          arrow="always"
          :autoplay="false"
          :height="carouselHeight"
        >
          <el-carousel-item v-for="(item, index) in imgList" :key="index">
            <img
              :src="item"
              alt=""
              ref="carouselImage"
              style="width: 100%;"
              @load="updateCarouselHeight"
            />
          </el-carousel-item>
        </el-carousel>
      </div>

      <div class="bgHome"></div>
    </div>
  </keep-alive>
</template>

<script>
import bus from '@/utils/bus'
import SubMenu from './menuTree.vue'
import { getBenner, getColumn, getSeries } from '@/api/homeApi'
export default {
  name: 'ZlfSearch',
  components: {
    SubMenu,
  },
  data() {
    return {
      styleNumber: '',
      activeName: '现货钻石',
      activeBPXL: '1',
      navBarFixed: false,
      mode: 'horizontal',
      clumn: [],
      clumnBPXL: [],
      filtList: [],
      carouselHeight: 'auto',
      imgList: [require('@/assets/img/home/banner1.jpg')],
    }
  },
  mounted() {
    // this.getBenner()
    // this.getColumn();
    // 事件监听滚动条
    window.addEventListener('scroll', this.watchScroll)
    window.addEventListener('resize', this.updateCarouselHeight)
    bus.$on('emptySearch', () => {
      this.styleNumber = null
    })
  },
  methods: {
    getBenner() {
      getBenner().then((res) => {
        res.data.forEach((element) => {
          this.imgList.push(element)
        })
      })
    },
    getColumn() {
      getColumn().then((res) => {
        res.data.forEach((item) => {
          this.clumn.push(item)
          if (item?.subList.length == 0) {
            this.filtList.push(item)
          } else {
            this.filtList.push(item?.subList)
          }
        })
        if (this.filtList) {
          bus.$emit(
            'getList',
            this.filtList.flat(Infinity)[0].id,
            this.filtList.flat(Infinity)[0].name,
            this.filtList.flat(Infinity)[0].code,
            'tab'
          )
          this.activeName = this.filtList.flat(Infinity)[0].name
        }
      })
    },
    handleSelect(key) {
      this.activeBPXL = ''
      this.activeName = key
      const item = this.filtList
        ?.flat(Infinity)
        .find((item) => item.name == key)
      bus.$emit('getList', item.id, key, item.code, 'tab')
    },
    handleSelectBPXL(key) {
      this.activeName = ''
      // bus.$emit('getStandardSeries', key);
      bus.$emit('getList', '', key, '', 'series')
    },
    watchScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      //  当滚动超过 50 时，实现吸顶效果
      if (scrollTop > 384) {
        this.navBarFixed = true
      } else {
        this.navBarFixed = false
      }
    },
    updateCarouselHeight() {
      this.$nextTick(() => {
        const carouselImages = this.$refs.carouselImage[0]
        let maxHeight = carouselImages.clientHeight
        this.carouselHeight = `${maxHeight}px`
      })
    },
    getFilterKeywords() {
      const item = this.filtList
        ?.flat(Infinity)
        .find((item) => item.name == this.activeName)
      bus.$emit('getList', item.id, this.styleNumber, item.code, 'search')
    },
  },
  beforeDestroy() {
    bus.$off('emptySearch')
    window.removeEventListener('scroll', this.watchScroll)
    window.removeEventListener('resize', this.updateCarouselHeight)
  },
}
</script>

<style>
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.navBarWrap {
  position: fixed;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 999;
  background: #fff;
  width: 100%;
}

/* .el-carousel__container {
	height: 380px !important;
} */

.box_shuqain .box_serar {
  background-color: #ec9368;
  width: 74px;
  padding: 6px;
  position: relative;
  left: -1px;
  height: 34px;
  font-size: 18px;
  color: #fff;
}

.box_input .el-input__inner {
  height: 34px !important;
  padding-left: 40px !important;
  background-color: #fff !important;
  border-radius: 0px !important;
  border: 1px solid #ec9368;
}

.box_input .el-icon-search:before {
  font-size: 18px;
}

.box_input .el-input__inner::placeholder {
  padding-left: 10px;
  color: #999;
  font-size: 18px !important;
}

.box_input .el-input__prefix {
  left: 10px;
}

.el-input__inner:focus,
.el-input__inner:hover {
  border: 1px solid #ec9368 !important;
  background: #fff !important;
}
</style>

<style scoped lang="scss">
::v-deep .el-input__icon {
  line-height: 35px !important;
}

::v-deep .el-input__prefix,
.el-input__suffix {
  line-height: 35px !important;
  height: 35px !important;
}

.searchBox {
  max-width: 350px;
  min-width: 150px;
  font-size: 0;
  height: 50px;
  display: flex;
  align-items: center;
  margin: 0 5px;
}

.el-button {
  border: 1px solid #ec9368;
}

.box_input {
  height: 34px;
  width: 320px;
}

.box_search {
  max-width: 1500px;
  margin: 0 auto;
}

.el-button:focus,
.el-button:hover {
  background: #ec9368;
  color: #fff;
  border: none;
}

.detai_box_img {
  max-width: 1500px;
  margin: 0 auto;
}

.search .box_shuqain {
  width: 100%;
  box-shadow: 0px 8px 12px #f5f5f5;
}

.bgHome {
  height: 5px;
  background: #f3f3f3;
}

.rel_commodity {
  display: flex;
  // height: 50px;
  justify-content: space-between;
  width: 100%;
  margin: 0 auto;
  background: #fff;
}

// .taBox {
// 	max-width: 950px;
// }

/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 0.01rem;
  opacity: 0;
  display: none;
}

.el-menu {
  border: none;

  /deep/ .el-menu-item {
    /* 选中菜单颜色 */
    font-size: 14px;

    &.is-active {
      border-bottom: 2px solid #ec9368 !important;
    }
  }

  ::v-deep .el-menu-item,
  .el-submenu__title {
    height: 50px;
    line-height: 50px;
  }

  ::v-deep .el-icon-arrow-down {
    font-size: 14px;
    right: 15px;
  }

  /* 子级菜单项 */
  /deep/ .el-submenu {
    position: relative;

    .el-submenu__title {
      display: flex;
      align-items: center;
      height: 50px;
      line-height: 50px;

      span {
        padding: 0 10px;
      }

      .el-icon-location {
        position: static;
        margin: 0;
        color: #013c807e;
      }
    }
  }
}
</style>
